import { render, staticRenderFns } from "./interactDetail.vue?vue&type=template&id=c00cc88c&scoped=true&"
import script from "./interactDetail.vue?vue&type=script&lang=js&"
export * from "./interactDetail.vue?vue&type=script&lang=js&"
import style0 from "./interactDetail.vue?vue&type=style&index=0&id=c00cc88c&prod&lang=less&scoped=true&"
import style1 from "./interactDetail.vue?vue&type=style&index=1&id=c00cc88c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00cc88c",
  null
  
)

export default component.exports